import { useObserver } from "mobx-react";
import { useStores } from "../../../store";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { MdMailOutline } from "react-icons/md";

export default function MailTypePopup(props) {
  const { PopupStore, RecuiterStore } = useStores();
  const status = [
    {
      status: "Hired Candidates",
      template: "hired",
      type: "jobPost",
      mailType: "hired",
    },
    {
      status: "Rejected candidates",
      template: "rejected",
      type: "jobPost interview",
      mailType: "rejected",
    },
    {
      status: "Short listed candidates",
      template: "update_on_application",
      type: "jobPost interview",
      mailType: "shortlisted",
    },
    {
      status: "Assessment in-complete",
      template: "incomplete_assessment",
      type: "jobPost interview",
      mailType: "incomplete",
    },
    {
      status: "Assessment Not-Started",
      template: "assessment_not_started",
      type: "jobPost interview",
      mailType: "notStarted",
    },
    {
      status: "Assessment Completed",
      template: "assessment_completed",
      type: "jobPost interview",
      mailType: "completed",
    },
    {
      status: "All Resumes",
      template: "update_on_application",
      type: "resume",
      mailType: "completed",
    },
    {
      status: "Resumes above 80%",
      template: "resume_above_80",
      type: "resume",
      mailType: "shortlisted",
    },
    {
      status: "Resumes rejected",
      template: "resume_rejected",
      type: "resume",
      mailType: "rejected",
    },

    // "Hired Candidates",
    // "Rejected candidates",
    // "Short listed candidates",
    // "Assessment in-complete",
    // "Assessment Not-Started",
    // "Assessment Completed",
  ];
  return useObserver(() => {
    return (
      <>
        {PopupStore.mailTypePopup ? (
          <div className=" h-screen w-screen overflow-y-auto z-[500] rounded fixed bottom-0 left-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40 shadow-lg gil-reg overflow-x-hidden no-scrollbar">
            <div
              onClick={(e) => e.stopPropagation()}
              className="fixed inset-0 bg-bg3 z-50 flex flex-col justify-center rounded-3xl overflow-y-scroll items-center md:min-w-[35%] md:max-w-[50%] lg:w-[60%] w-[90%] h-[65%] tc3:h-[80%] md:h-[45%] lg:h-[35%] m-auto  no-scrollbar"
            >
              <div className="flex flex-col justify-between h-full py-5 w-[100%] md:w-[100%] lg:[100%] border">
                <AiOutlineCloseCircle
                  className="text-primary absolute text-2xl cursor-pointer top-2 right-2"
                  onClick={() => PopupStore.setMailTypePopup(false)}
                />
                <div className="flex flex-col justify-center h-full my-4 gap-4 p-8 overflow-y-scroll">
                  <span className="flex items-center gap-4">
                    <span className="w-12 h-12 bg-primary2 rounded-full flex items-center justify-center">
                      <MdMailOutline className="w-6 h-6" />
                    </span>
                    <span className="flex flex-col">
                      <span className="font-semibold text-lg">
                        Send mail to
                      </span>
                      <span className="gil-reg text-sm text-[#9B9B9B]">
                        Select any one option from below
                      </span>
                    </span>
                  </span>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {status
                      .filter((status) =>
                        status.type.includes(RecuiterStore.remainderMailType)
                      )
                      .map((status, index) => (
                        <button
                          key={index}
                          className={`px-4 py-2 border  rounded-md
                           ${
                             RecuiterStore.categories[status.mailType]
                               .length === 0
                               ? " cursor-not-allowed "
                               : " cursor-pointer"
                           }
                           ${
                             RecuiterStore.mailType === status.status
                               ? " bg-primary text-white"
                               : " border-gray-300  bg-white text-gray-600 whitespace-nowrap hover:bg-gray-100"
                           }`}
                          onClick={() => {
                            if (
                              RecuiterStore.categories[status.mailType]
                                .length === 0
                            ) {
                              return;
                            }
                            RecuiterStore.setMailType(status.status);
                            RecuiterStore.setMailTemplate(status.template);
                            console.log(
                              RecuiterStore.categories[status.mailType]
                            );

                            RecuiterStore.setReceiptentMails(
                              RecuiterStore.categories[status.mailType]
                            );
                          }}
                        >
                          {status.status}
                        </button>
                      ))}
                  </div>
                  <div className="flex justify-end mt-4 mb-4">
                    <button
                      className="px-8 py-2 bg-orange-500 text-white font-medium rounded-lg hover:bg-orange-600 focus:outline-none"
                      onClick={() => {
                        if (RecuiterStore.mailType.length === 0) {
                          alert("Please select any option");
                          return;
                        }
                        props.handleNext();
                      }}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </>
    );
  });
}
